import { TextInput, required, ReferenceInput, SelectInput } from "react-admin";
import { Grid } from "@mui/material";
import { notificationsRequests } from "api/notificationsApi";
import { administrationRequests } from "api/administrationApi";

const SaveForm = () => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        md={4}
        sm={6}
        xs={12}
      >
        <TextInput
          label="Име на български език"
          source="nameBg"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        md={4}
        sm={6}
        xs={12}
      >
        <TextInput
          label="Име на английски език"
          source="nameEn"
          validate={required()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceInput
          source="structuralUnitId"
          reference={administrationRequests.getStructuralUnitsSelect()}
          filter={{ filterByUser: true }}
        >
          <SelectInput
            label="Структурна единица"
            validate={[required()]}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceInput
          source="emailGroupId"
          reference={notificationsRequests.getEmailGroupsSelect()}
        >
          <SelectInput
            label="Имейл група"
            validate={[required()]}
          />
        </ReferenceInput>
      </Grid>
    </Grid>
  );
};
export default SaveForm;
